export const FAKE_AUTO_MESSAGE_DELAY = 1000;
